import { SCREEN_ANALYTICS, ScreenAnalytics } from '@/constants/analytics'
import { ENTRY_PATH } from '@/constants/od-session-context'
import { getEntryPath } from '@/utils/get-entry-path/get-entry-path'

type ScreenName = Pick<
  ScreenAnalytics,
  'START_SCAN' | 'ACTIVATE' | 'GO' | 'PARTNER_LINK' | 'CONNECT'
>

export function getExperienceScreenName(): ScreenName[keyof ScreenName] {
  const entryPath = getEntryPath()
  switch (entryPath) {
    case ENTRY_PATH.STARTSCAN:
      return SCREEN_ANALYTICS.START_SCAN
    case ENTRY_PATH.ACTIVATE:
      return SCREEN_ANALYTICS.ACTIVATE
    case ENTRY_PATH.GO:
      return SCREEN_ANALYTICS.GO
    case ENTRY_PATH.PN:
      return SCREEN_ANALYTICS.PARTNER_LINK
    default:
      return SCREEN_ANALYTICS.CONNECT
  }
}
